import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eDanThuocActionTypeIds, IDanThuocActionTypes } from "../../action-types/y-te/IDanThuocActionTypes";
import { IDanThuocPageStateModel } from "../../page-state-model/y-te/IDanThuocPageState";

const initialState: IDanThuocPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	dan_thuocs: [],
	dan_thuoc_editing: undefined,
	dan_thuoc_selected_ids: [],
	dan_thuoc_selected_id: 0,
	is_loading_detail: false,
	is_show_detail_modal: false,
	is_show_delete_confirm: false,

	chitiet_status: ePageBaseStatus.is_not_initialization,
	dan_thuoc_chitiets: [],
	dan_thuoc_chitiet_editing: undefined,
	is_show_chitiet_detail_modal: false,
	is_show_chitiet_delete_confirm: false,

	dan_thuoc_hinhanhs: []
}

export const danThuocReducer = (state: IDanThuocPageStateModel = initialState, action: IDanThuocActionTypes): IDanThuocPageStateModel => {
	switch (action.type) {
		case eDanThuocActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eDanThuocActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				dan_thuocs: action.payload
			}
		case eDanThuocActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				dan_thuocs: []
			}
		case eDanThuocActionTypeIds.LOAD_DETAIL_START:
			return {
				...state,
				is_loading_detail: true
			}
		case eDanThuocActionTypeIds.LOAD_DETAIL_SUCCESS:
			// SP chi tiết không trả đủ các cột hiển thị của lưới (ma_hs, ts_hocsinh_hoten...)
			// nên gộp với dòng lưới đang chọn thay vì thay thế hoàn toàn.
			return {
				...state,
				is_loading_detail: false,
				dan_thuoc_editing: { ...state.dan_thuoc_editing, ...action.payload }
			}
		case eDanThuocActionTypeIds.LOAD_DETAIL_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				is_loading_detail: false
			}
		case eDanThuocActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				dan_thuoc_editing: action.payload
			}
		case eDanThuocActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				dan_thuoc_editing: undefined
			}
		case eDanThuocActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				dan_thuoc_selected_ids: action.payload
			}
		case eDanThuocActionTypeIds.CHANGE_SELECTED_ID:
			return {
				...state,
				dan_thuoc_selected_id: action.payload
			}
		case eDanThuocActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true,
				dan_thuoc_editing: action.payload
			}
		case eDanThuocActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false,
				dan_thuoc_editing: undefined
			}
		case eDanThuocActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eDanThuocActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success(action.payload ? "Cập nhật thành công" : "Thêm mới thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				dan_thuoc_editing: undefined
			}
		case eDanThuocActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		case eDanThuocActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eDanThuocActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false,
				dan_thuoc_editing: undefined,
				dan_thuoc_selected_ids: []
			}
		case eDanThuocActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		case eDanThuocActionTypeIds.CAPNHAT_XULY_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eDanThuocActionTypeIds.CAPNHAT_XULY_SUCCESS:
			NotifyHelper.Success("Cập nhật thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				dan_thuoc_selected_ids: []
			}
		case eDanThuocActionTypeIds.CAPNHAT_XULY_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		case eDanThuocActionTypeIds.LOAD_CHITIET_START:
			return {
				...state,
				chitiet_status: ePageBaseStatus.is_loading
			}
		case eDanThuocActionTypeIds.LOAD_CHITIET_SUCCESS:
			return {
				...state,
				chitiet_status: ePageBaseStatus.is_completed,
				dan_thuoc_chitiets: action.payload
			}
		case eDanThuocActionTypeIds.LOAD_CHITIET_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				chitiet_status: ePageBaseStatus.is_completed,
				dan_thuoc_chitiets: []
			}
		case eDanThuocActionTypeIds.SHOW_CHITIET_DETAIL:
			return {
				...state,
				is_show_chitiet_detail_modal: true,
				dan_thuoc_chitiet_editing: action.payload
			}
		case eDanThuocActionTypeIds.CLOSE_CHITIET_DETAIL:
			return {
				...state,
				is_show_chitiet_detail_modal: false,
				dan_thuoc_chitiet_editing: undefined
			}
		case eDanThuocActionTypeIds.SAVE_CHITIET_START:
			return {
				...state,
				chitiet_status: ePageBaseStatus.is_saving
			}
		case eDanThuocActionTypeIds.SAVE_CHITIET_SUCCESS:
			NotifyHelper.Success(action.payload ? "Cập nhật thành công" : "Thêm mới thành công")
			return {
				...state,
				chitiet_status: ePageBaseStatus.is_need_reload,
				is_show_chitiet_detail_modal: false,
				dan_thuoc_chitiet_editing: undefined
			}
		case eDanThuocActionTypeIds.SAVE_CHITIET_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				chitiet_status: ePageBaseStatus.is_completed
			}
		case eDanThuocActionTypeIds.SHOW_CHITIET_CONFIRM:
			return {
				...state,
				is_show_chitiet_delete_confirm: true,
				dan_thuoc_chitiet_editing: action.payload
			}
		case eDanThuocActionTypeIds.CLOSE_CHITIET_CONFIRM:
			return {
				...state,
				is_show_chitiet_delete_confirm: false,
				dan_thuoc_chitiet_editing: undefined
			}
		case eDanThuocActionTypeIds.DELETE_CHITIET_START:
			return {
				...state,
				chitiet_status: ePageBaseStatus.is_deleting
			}
		case eDanThuocActionTypeIds.DELETE_CHITIET_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				chitiet_status: ePageBaseStatus.is_need_reload,
				is_show_chitiet_delete_confirm: false,
				dan_thuoc_chitiet_editing: undefined
			}
		case eDanThuocActionTypeIds.DELETE_CHITIET_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				chitiet_status: ePageBaseStatus.is_completed,
				is_show_chitiet_delete_confirm: false
			}
		case eDanThuocActionTypeIds.LOAD_HINHANH_START:
			return {
				...state
			}
		case eDanThuocActionTypeIds.LOAD_HINHANH_SUCCESS:
			return {
				...state,
				dan_thuoc_hinhanhs: action.payload
			}
		case eDanThuocActionTypeIds.LOAD_HINHANH_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				dan_thuoc_hinhanhs: []
			}
		default:
			return state;
	}
}
